<template lang="html">
  <span
    class="atlas-flag flag-icon"
    :class="css" />
</template>

<script>
export default {
  name: 'AtlasFlag',
  props: {
    code: {
      type: String,
      required: true
    },
    squared: {
      type: Boolean
    },
    rounded: {
      type: Boolean
    }
  },
  computed: {
    css () {
      let classCss = 'flag-icon-' + this.code.toLowerCase()
      if (this.squared || this.rounded) classCss += ' flag-icon-squared'
      if (this.rounded) classCss += ' flag-icon-rounded'
      return classCss
    }
  }
}
</script>

<style lang="scss">
@import "~flag-icon-css/css/flag-icon.css";
.flag-icon-rounded {
  border-radius: 50%;
}
</style>
